import { FormElement } from '@hb/shared'
import { AnyObject, FormApi } from 'final-form'
import { useEffect } from 'react'
import { useForm } from 'react-final-form'

export const FormRegistrar = <T extends AnyObject>({
  registerForm,
  field,
}: {
  registerForm: (form: FormApi<T> | null) => void
  field: FormElement
}) => {
  const form = useForm<T>()

  useEffect(() => {
    registerForm(form)
    return () => registerForm(null)
  }, [form, registerForm, field])
  return null
}
